// Keys are Next.js route patterns, never URLs containing room IDs or query strings.
// Restricted pages deny every event except their explicitly listed types.
export const PROVIDER_EVENT_PAGE_POLICIES: Readonly<
  Record<string, { allowedEventTypes: readonly string[] }>
> = {
  '/[roomId]': { allowedEventTypes: [] },
  '/call/meal-plan/[roomId]': { allowedEventTypes: [] },
};

export function isProviderEventAllowed(
  route: string,
  eventType: string,
): boolean {
  const policy = PROVIDER_EVENT_PAGE_POLICIES[route];
  return !policy || policy.allowedEventTypes.includes(eventType);
}
